const Config = {
  saleTime: {
    presale: 1638846000, // 	Tue Oct 26 2021 01:00:00 GMT+0000
    public: 1639018800, //	Thu Oct 28 2021 12:00:00 GMT+0000
  },
  contractAddress: "0xA0A6c9354046a68529B339e3123e261F9e12bC68",
  mintStarted: false,
};
export default Config;
